import React from 'react';
import FacingTrouble from '../../components/FacingTrouble';
import '../../../styles/irctcCreateAccountSuccessPage.css';
import { getAppEnv } from '../../../../config/env';
import { isMobile, navigateTo } from '../../../utils/commonUtils';
import {
  FACING_TROUBLE_PAGE_TITLE,
  getContinueBookingUrl,
  getFacingTroubleList
} from '../../../utils/RailsSEOConstants';
import PropTypes from 'prop-types';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;
const IrctcCreateAccountSuccessPage = (props) => {
  const { customClass } = props;
  const isMobileDevice = isMobile();
  return (
    <div className={`${customClass} irctcVerified`}>
      <div className="irctcVerified__cntnt">
        <div className="imgWrap">
          <img src={`${PUBLIC_URL}/static/public/tickIcon.png`} alt={''} />
        </div>
        <h3>IRCTC Account successfully created</h3>
        <p className="appendBottom80">
          Proceed to our funnel to continue
          <br /> booking your train ticket.
        </p>
        <button
          className={`blueButtonRails ${isMobileDevice ? 'fullWidth' : ''} appendTop30`}
          onClick={() => navigateTo(getContinueBookingUrl())}
        >
          Continue Booking
        </button>
      </div>
      <FacingTrouble facingTroubleList={getFacingTroubleList(FACING_TROUBLE_PAGE_TITLE.CREATE_ACCOUNT_TITLE)} />
    </div>
  );
};

IrctcCreateAccountSuccessPage.propTypes = {
  customClass: PropTypes.string
};

export default IrctcCreateAccountSuccessPage;
